import gql from "graphql-tag";

export default gql`
  query ($groupBy: String!) {
    itemAmountData(groupBy: $groupBy) {
      amount
      period
    }
  }`;